import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const AcceptableUse = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 py-12 px-6">
        <div className="container mx-auto max-w-4xl">
          <h1 className="font-heading text-4xl font-bold mb-8" data-testid="acceptable-use-title">Acceptable Use Policy</h1>
          <div className="prose max-w-none space-y-6 text-muted-foreground">
            <p className="text-sm text-muted-foreground"><em>Last Updated: {new Date().toLocaleDateString()}</em></p>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">1. Purpose</h2>
              <p>This Acceptable Use Policy ("AUP") defines prohibited uses of ScanMyAd. Violation may result in account suspension or termination.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">2. Prohibited Activities</h2>
              
              <h3 className="font-heading text-xl font-semibold text-foreground mb-2">Illegal Content:</h3>
              <p>You may NOT submit advertising content that:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Promotes illegal products or services</li>
                <li>Violates intellectual property rights</li>
                <li>Contains hate speech, violence, or discrimination</li>
                <li>Facilitates fraud or deceptive practices</li>
                <li>Violates export controls or sanctions</li>
              </ul>

              <h3 className="font-heading text-xl font-semibold text-foreground mb-2 mt-4">System Abuse:</h3>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Attempt to reverse engineer AI models</li>
                <li>Overload or disrupt service infrastructure</li>
                <li>Use automated scrapers or bots (except via official API)</li>
                <li>Bypass rate limits or subscription tiers</li>
              </ul>

              <h3 className="font-heading text-xl font-semibold text-foreground mb-2 mt-4">Account Misuse:</h3>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Share account credentials</li>
                <li>Create multiple accounts to bypass limits</li>
                <li>Impersonate other users or entities</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">3. Restricted Content Categories</h2>
              <p>While not prohibited, the following categories require extra caution:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li><strong>Health Claims:</strong> Must comply with FDA, Health Canada, or local regulations</li>
                <li><strong>Financial Products:</strong> Must include required disclosures</li>
                <li><strong>Political Advertising:</strong> Subject to platform-specific authorization</li>
                <li><strong>Cryptocurrency:</strong> Restricted on some platforms</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">4. Data Usage Restrictions</h2>
              <p>You may NOT:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Submit content containing personal data without consent</li>
                <li>Use the service to collect or harvest third-party data</li>
                <li>Reproduce or redistribute AI analysis output for competitive services</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">5. Compliance Responsibility</h2>
              <p>Users are responsible for:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Ensuring content complies with local laws</li>
                <li>Obtaining necessary licenses or approvals</li>
                <li>Verifying AI analysis accuracy before use</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">6. Enforcement</h2>
              <p>Violation of this AUP may result in:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Warning and content removal</li>
                <li>Temporary account suspension</li>
                <li>Permanent account termination</li>
                <li>Legal action (in cases of fraud or illegal activity)</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">7. Reporting Violations</h2>
              <p>To report AUP violations:</p>
              <p className="mt-2">Email: support@scanmyad.com</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">8. Updates</h2>
              <p>We may update this AUP at any time. Continued use constitutes acceptance of changes.</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AcceptableUse;
